import { Box, styled } from '@mui/material';

const ListGroupItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0.5rem 1rem',
  color: (theme.vars || theme).palette.text.primary,
  textDecoration: 'none',
  backgroundColor: (theme.vars || theme).palette.background.paper,
  border: `1px solid ${(theme.vars || theme).palette.borderColor}`,
  '& > em': {
    marginLeft: '1rem',
  },

  '& + &': {
    borderTopWidth: 0,
  },

}));

export default ListGroupItem;
